import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { buttonSubmitStyle } from '../../../components/ButtonSubmit';
import Caption from '../../../components/Caption';
import { NAVIGATION } from '../../App/constants';
import { FAQ_URL, questionPropTypes } from '../constants';
import ArticleComponent from './ArticleComponent';
import FaqDiv from './FaqDiv';
import FaqH1 from './FaqH1';
import FaqText from './FaqText';
import messages from './messages';
import Redirect from './Redirect';
import RelatedQuestions from './RelatedQuestions';

const CustomFaqH2 = styled(FaqH1)`
  ${tw`mt-0 sm:mt-0`};
`;

const TextEnd = styled.div`
  ${tw`text-right mr-abs2`};
`;

const TictactripText = styled(FaqText)`
  ${tw`font-bold pr-0`};
`;

const FaqCaption = styled(Caption)`
  ${tw`text-text ml-abs2 mt-abs2 text-bold`}
  font-style: italic;
`;

const AskQuestion = styled.a`
  ${buttonSubmitStyle}
  ${tw`w-8 items-center mt-abs4 mx-auto
    bg-primary400 hover:bg-primary400`}
    @media (max-width: 992px) {
    width: 90%;
    text-align: center;
  }
`;

const ArticlePage = ({ article, categoryName, relatedQuestions }) => {
  const category = categoryName || article.category[0];
  return (
    <FaqDiv>
      <FormattedMessage {...messages.returnToCategory}>
        {(msg) => (
          <Redirect
            id={`redirectCategory-${category}`}
            text={msg}
            url={`${FAQ_URL}/${category}`}
          />
        )}
      </FormattedMessage>
      <CustomFaqH2>{article.title}</CustomFaqH2>
      {article.content.map((content, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ArticleComponent key={`${content.type}-${index}`} content={content} />
      ))}
      <TextEnd>
        <TictactripText>
          <FormattedMessage {...messages.tictactripTeam} />
        </TictactripText>
        <FormattedMessage {...messages.editedTime}>
          {(msg) => (
            <FaqCaption>
              {msg} {article.updatedDate}.
            </FaqCaption>
          )}
        </FormattedMessage>
      </TextEnd>
      {!isEmpty(relatedQuestions) && (
        <RelatedQuestions relatedQuestions={relatedQuestions} />
      )}
      <AskQuestion href={NAVIGATION.SUPPORT} target="_blank">
        <FormattedMessage {...messages.askQuestion} />
      </AskQuestion>
    </FaqDiv>
  );
};

ArticlePage.propTypes = {
  article: questionPropTypes,
  categoryName: PropTypes.string,
  relatedQuestions: PropTypes.arrayOf(questionPropTypes),
};

export default ArticlePage;
